// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type GetFolderRequest from "../contract/GetFolderRequest";

export default function getFolderRequest(data: GetFolderRequest): GetFolderRequest {
    const result: GetFolderRequest = {
        __type: "GetFolderRequest:#Exchange",
        ...data,
    };
    
    return result;
}
